import React from "react"
import Helmet from "react-helmet"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { Container, Section, SectionPageTitle } from "../components/section"
import ProductCardList from "../components/TabProductCardList"
import Sale from "../components/Sale"
import styled from 'styled-components'
import SaleBg from "../images/sale/salebg.jpg"
import SpecialProductSection from "../sections/Home/SpecialProductSection";

const SaleWrap = styled(Section)`   
  width:100%;
  background-color:#400b01;
  background-repeat: no-repeat;
  background-size: 100% 100%;    
  background-position: 0 0;
  background-image:${props => props.bg};    
`
const SaleHelpText = styled.div`
  white-space: nowrap;
  color: #fff;
  text-align: center;
  font-weight: 400;
  padding: 30px 0 10px;
  font-size: 10px;
  line-height: 16px;
  letter-spacing: 0.1px;
  @media (min-width: 576px) {
    font-size: 10px;
    line-height: 16px;
  }
  @media (min-width: 992px) {
    font-size: 12px;
  }
  @media (min-width: 1200px) {
    font-size: 14px;    
  }
`

const SpecialsPage = (pageData) => {
  const products = pageData.data.allContentfulProduct;
  let productsData = []
  productsData = products.edges

  let specialProductsData = [];
  products.edges.forEach(function (item) {
    if (item.node.specialProduct) {
      specialProductsData.push(item)
    }
  });
  
  return (
    <Layout location={pageData.location} noSaleSticky>
      <Helmet><meta name="robots" content="noindex, nofollow" /></Helmet>
      <SEO title="Title" description="Description" />
        <SaleWrap pt="110px" pb="5px" xpt="60px" xpb="5px" bg={`url(${SaleBg})`}>
          <Container><Sale /></Container>          
          <SpecialProductSection data={specialProductsData} location={pageData.location} />
          <SaleHelpText>*Offer Valid in Select States | *Prices Vary by Location</SaleHelpText>        
        </SaleWrap>
        <Section pt="90px" pb="90px" xpt="60px" xpb="60px">
          <Container>
            <SectionPageTitle mb="20px" textAlign="center">Check Out Our Most Popular Buildings</SectionPageTitle>
            <ProductCardList
              data={productsData}
              limit="all"
            />
          </Container>
        </Section>      
    </Layout>
   )
}

export default SpecialsPage

export const pageQuery = graphql`
  query SpecialsPageQuery {
    contentfulProductListPage {
      metaTitle
      metaDescription
      heroTitle
      heroDescription {
        childMarkdownRemark {
          html
        }
      }
    }
    allContentfulProduct {
      edges {
        node {
          id
          productName
          url
          popularLabel
          specialProduct
          image {
            fluid {
              base64
              aspectRatio
              src
              srcSet
              srcSetWebp
              srcWebp
            }
          }
          width
          height
          length
          totalPrice
          depositPrice
          priceDescription
          productCategory {
            link
          }
          featuresImage {
            title
            file {
              url
            }
          }
          productCategory {
            link
          }
          productRoof {
            roofName
          }
        }
      }
    }
  }
`